import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private subject = new Subject<any>();
    private keepAfterRouteChange = false;

    constructor(
        private router: Router,
        public snackBar: MatSnackBar
    ) {
        // clear alert messages on route change unless 'keepAfterRouteChange' flag is true
        this.router.events.subscribe(event => {
            if (event instanceof NavigationStart) {
                if (this.keepAfterRouteChange) {
                    // only keep for a single route change
                    this.keepAfterRouteChange = false;
                } else {
                    // clear alert message
                    this.clear();
                }
            }
        });
    }

    getAlert(): Observable<any> {
        return this.subject.asObservable();
    }

    success(message: string, keepAfterRouteChange = false) {
        this.keepAfterRouteChange = keepAfterRouteChange;
        this.subject.next({ type: 'success', text: message });
    }

    error(message: string, keepAfterRouteChange = false) {
        if (message)
            if (message.includes(':')) {
                var statusCode = message.split(":")
                if (statusCode[0] == "425") {
                    var message = statusCode[1].trim()
                    if (message == 'Document contains Virus') {
                        this.snackBar.open("Virus detected in the file", "Close", { duration: 5000 })
                    } else {
                        this.snackBar.open("Virus Scanning in Progress. Please try again later", "Close", { duration: 5000 })
                    }
                } else {
                    this.keepAfterRouteChange = keepAfterRouteChange;
                    this.subject.next({ type: 'error', text: message });
                }
            } else {
                this.keepAfterRouteChange = keepAfterRouteChange;
                this.subject.next({ type: 'error', text: message });
            }
    }

    clear() {
        // clear by calling subject.next() without parameters
        this.subject.next();
    }
}